export const WORKPLACE_PATHS = {
  dashboard: "/",
  campaigns: "/campaigns",
  upload: "/upload",
  admin: "/admin",
  allocation_basis: "/allocation-basis",
  manual_request: "/requests/new",
  workflow: "/workflow",
  budget: "/budget",
  reports: "/reports",
  sheets: "/sheets",
  exports: "/exports",
  ui_kit: "/ui-kit"
};

export function canOpenWorkplaceFromNavigation(navigation, workplace, demoAuthEnabled = false) {
  if (workplace === "ui_kit") return Boolean(demoAuthEnabled);
  if (!navigation) return true;
  return navigation.some((item) => item?.id === workplace);
}

export function routeFromPath(pathname, fallback = "dashboard") {
  const path = (pathname || "/").replace(/\/+$/, "") || "/";
  const requestMatch = path.match(/^\/requests\/(\d+)$/);
  if (requestMatch) return { workplace: "workflow", requestId: requestMatch[1] };
  const importMatch = path.match(/^\/imports\/(\d+)$/);
  if (importMatch) return { workplace: "upload", importId: importMatch[1] };
  if (path === "/requests" || path === "/workflow") return { workplace: "workflow" };
  if (path === "/requests/new") return { workplace: "manual_request" };
  if (path.startsWith("/sheets/")) return { workplace: "sheets", sheetViewId: path.split("/")[2] };
  const matched = Object.entries(WORKPLACE_PATHS).find(([, route]) => route === path);
  return { workplace: matched?.[0] || fallback || "dashboard" };
}

export function pathForWorkplace(workplace, detailId) {
  if (detailId && workplace === "workflow") return `/requests/${detailId}`;
  if (detailId && workplace === "upload") return `/imports/${detailId}`;
  return WORKPLACE_PATHS[workplace] || "/";
}
